import { createSelector } from '@reduxjs/toolkit';
import { selfMsgSelector } from './self';

const imageTypeSelector = createSelector(selfMsgSelector, (messages) => messages.imageType);

export default imageTypeSelector;
